import {
  ArrowLeft,
  BanIcon,
  BellIcon,
  ChevronDown,
  CrossIcon,
  InformationCircle,
  KanbanIcon,
  Loading2,
  Localisation,
  Plus,
  SearchLoop,
  SortIcon,
  SwitchIcon,
  TableIcon,
} from 'assets/icons/index.js';
import axios from 'axios';
import Button from 'components/button/index.js';
import Badge from 'components/badge/badge.js';
import useModal from 'components/modal/useModal.js';
import Pagination from 'components/pagination/pagination.js';
import SubNavbar from 'components/SubNavbar/SubNavbar';
import UseContext from 'hooks/useContext.js';
import useWindowDimensions from 'hooks/useWindowDimensions.js';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiDatabase from 'server';
import Tooltip from '../../../../../components/tooltips/Tooltips';
import useAbortController from '../../../../../hooks/useAbortController';
import KanbanFicheVivier from './components/kanban.fiche.vivier';
import TableFicheVivier from './components/table.fiche.vivier.js';
import FilterDropdown from '../../../../../components/filter/FilterDropdown';
import {
  applyPatchToFicheRow,
  findPatchForUser,
} from '../../../../../utils/vivierUserPatch';

function BodyFicheVivier() {
  const { toggle } = useModal();
  const navigate = useNavigate();
  const {
    setInfoVivier,
    refreshVivierLog,
    usersVivier,
    setUsersVivier,
    setObjID,
    setModalData,
  } = UseContext();
  const { id: rawId } = useParams();
  const id = rawId?.includes('?') ? rawId.split('?')[0] : rawId;

  const { height, width } = useWindowDimensions();
  const [search, setSearch] = useState('');
  const [optionSearch, setOptionSearch] = useState('');
  const [selectMQ, setSelectMQ] = useState(false);
  const [selectGP, setSelectGP] = useState(false);
  const [selectProfil, setSelectProfil] = useState(false);
  const [searchCandidatWaiting, setSearchCandidatWaiting] = useState(true);

  const [selectApp, setSelectApp] = useState(false);
  const [sortName, setSortName] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // Pour le kanban, on charge tous les utilisateurs (limite élevée), sinon 25 par page
  const isKanbanMode = id !== '64e8cfd10b4f73f442432c9f';
  const [limitElement, setLimitElement] = useState(isKanbanMode ? 10000 : 25);
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [globalUsersVivier, setGlobal] = useState();
  const [data, setData] = useState();
  const [result, setResult] = useState([]);
  const [vivier, setVivier] = useState();
  const [listAddVivier, setAddVivier] = useState([]);
  const [lastLogVivier, setLastLogVivier] = useState('');
  const [isVivierExclude, setVivierExclude] = useState(false);
  const [isVivierLink, setIsVivierLink] = useState(true);
  const [isVivierKanban, setIsVivierKanban] = useState(isKanbanMode);
  const [osChecked, setOsChecked] = useState({
    web: true,
    app: true,
  });
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [departmentChecked, setDepartmentChecked] = useState({ other: true });
  const [sortChecked, setSortChecked] = useState({
    a_z: false,
    recent: false,
  });
  //get params from url
  const params = new URLSearchParams(window.location.search);
  const searchListVivier = params.get('searchListVivier');
  const pageListVivier = params.get('pageListVivier');

  const [statusCounts, setStatusCounts] = useState({
    wish: 0,
    test: 0,
    valid: 0,
    refused: 0,
    archive: 0,
  });
  const [selectedColumn, setSelectedColumn] = useState(null);

  const getAbortController = useAbortController();

  const token = localStorage.getItem('xsrfToken');

  const kanbanColumns = [
    {
      name: 'wish',
      title: 'Souhait',
      icon: '🧞',
      description:
        'Profils ayant indiqué vouloir participer à ce type de missions.',
    },
    {
      name: 'test',
      title: 'Test',
      icon: '⏳',
      description: "Profils qualifiés par l'équipe de recrutement.",
    },
    {
      name: 'valid',
      title: 'Validé',
      icon: '✅',
      description: 'Profils notés positivement par un client.',
    },
    {
      name: 'refused',
      title: 'Refusé',
      icon: '❌',
      description: "Profils refusés par l'équipe de recrutement.",
    },
    {
      name: 'archive',
      title: 'Archivé',
      icon: '📦',
      description:
        'Profils indisponibles indéfiniment et/ou ne sont plus actif depuis plus de 45 jours.',
    },
  ];

  useEffect(() => {
    ApiDatabase.getCityDepartments(
      { token },
      (data) => {
        const opts = [
          ...data.map((d) => ({ value: d.toLowerCase(), label: d })),
          { value: 'other', label: 'Aucun' },
        ];
        setDepartmentOptions(opts);
        const defaults = {};
        data.forEach((d) => { defaults[d.toLowerCase()] = true; });
        defaults.other = true;
        setDepartmentChecked(defaults);
      },
      () => {}
    );
  }, []);

  useEffect(() => {
    if (id && token) {
      ApiDatabase.getLogVivier(
        { token, idVivier: id, limit: 1, page: 1 },
        (data) => {
          if (Object.keys(data.logVivier).length > 0) {
            //get first log vivier
            const dateLogVivier = new Date(data.logVivier[0].createdAt);
            const dateLogVivierFormat = `${('0' + dateLogVivier.getDate())
              .toString()
              .slice(-2)}/${('0' + (dateLogVivier.getMonth() + 1))
              .toString()
              .slice(-2)}/${dateLogVivier.getFullYear()} à ${(
              '0' + dateLogVivier.getHours()
            )
              .toString()
              .slice(-2)}:${('0' + dateLogVivier.getMinutes())
              .toString()
              .slice(-2)}`;
            setLastLogVivier(`Notifié le ${dateLogVivierFormat}`);
          } else {
            setLastLogVivier(null);
          }
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.error(err);
            toast.error('Une erreur est survenue');
          }
        },
        { skipCache: true }
      );
    }
  }, [id, refreshVivierLog]);

  const handleSelectProfil = (e) => {
    e.preventDefault();
    setSelectProfil((prevState) => !prevState);
  };
  const handleSelectApp = (e) => {
    e.preventDefault();
    setSelectApp((prevState) => !prevState);
  };
  const handleDelete = (e) => {
    e.preventDefault();
    toggle('vivier_add');
  };
  const handleNotification = (e) => {
    e.preventDefault();
    setInfoVivier({ listUsers: globalUsersVivier });
    toggle('vivier_notification');
    setObjID(id);
  };

  const manageCandidatSearch = async () => {
    setSearchCandidatWaiting(true);
    const controller = getAbortController();

    try {
      const filterOptions = {
        ...osChecked,
        department: departmentChecked,
        ...sortChecked,
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}vivier/vivierFiche`,
        {
          signal: controller.signal,
          params: {
            page: currentPage,
            limit: limitElement,
            search: search,
            optionSearch: optionSearch,
            profil: selectProfil,
            id: id,
            filterOptions: JSON.stringify(filterOptions),
            vivierStatus: selectedColumn || '',
          },
        }
      );

      if (selectProfil) setCurrentPage(1);
      setCountPerPage(data.countPerPage);
      setCountTotal(data.count);
      setData(data.count);
      // Les users sont déjà paginés par le serveur
      setResult(data.users);
      setTotalPages(data.countPages);
      setSearchCandidatWaiting(false);
      setVivier(data.vivier);
      setIsVivierLink(data.vivier.qualification?.id_qualification ?? false);
      // Mettre à jour les compteurs par status pour le kanban
      if (data.statusCounts) {
        setStatusCounts(data.statusCounts);
      }
      // Ne plus charger tous les user_preferences - pas besoin
      setGlobal(data.users?.map(u => u._id) || []);
    } catch (error) {
      if (error.name !== 'CanceledError') {
        console.error('An error occurred:', error);
        setSearchCandidatWaiting(false);
      }
    }
  };

  let timerViverSearch = '';
  useEffect(() => {
    timerViverSearch = setTimeout(async () => {
      await manageCandidatSearch();
    }, 400);
    return () => clearTimeout(timerViverSearch);
  }, [
    search,
    optionSearch,
    selectApp,
    selectMQ,
    sortName,
    currentPage,
    selectProfil,
    id,
    osChecked,
    departmentChecked,
    sortChecked,
    selectedColumn,
  ]);

  useEffect(() => {
    if (id) {
      if (id === '64e8cfd10b4f73f442432c9f') {
        setVivierExclude(true);
      } else {
        setVivierExclude(false);
      }
    }
  }, [id]);

  // Mettre à jour la limite quand on bascule entre kanban et table
  useEffect(() => {
    if (isVivierKanban) {
      setLimitElement(10000); // Charger tous les utilisateurs pour le kanban
      setCurrentPage(1);
    } else {
      setLimitElement(25); // Pagination normale pour la table
    }
  }, [isVivierKanban]);

  useEffect(() => {
    if (!usersVivier.length) return;

    const updatedResult = result.map((resultItem) => {
      const patch = findPatchForUser(usersVivier, resultItem._id);
      if (!patch) return resultItem;
      return applyPatchToFicheRow(resultItem, patch, vivier?.name);
    });

    setResult(updatedResult);
    setUsersVivier([]);
    setInfoVivier({ listUsers: [] });
    setAddVivier([]);
    setData(updatedResult.filter((row) => !row.isDeleted).length);
  }, [usersVivier]);

  // Convert sortChecked to list format for FilterDropdown
  const sortList = [
    { value: 'a_z', label: 'A-Z', checked: sortChecked.a_z },
    { value: 'recent', label: 'Récent', checked: sortChecked.recent },
  ];

  const handleSortChange = (updatedList) => {
    const newSortChecked = { a_z: false, recent: false };
    updatedList.forEach((item) => {
      if (item.checked) {
        newSortChecked[item.value] = true;
      }
    });
    setSortChecked(newSortChecked);
  };

  // Convert osChecked to list format for FilterDropdown
  const osList = [
    { value: 'web', label: 'Web', checked: osChecked.web },
    { value: 'app', label: 'App', checked: osChecked.app },
  ];

  const handleOsChange = (updatedList) => {
    const newOsChecked = { web: false, app: false };
    updatedList.forEach((item) => {
      if (item.checked) {
        newOsChecked[item.value] = true;
      }
    });
    setOsChecked(newOsChecked);
  };

  const departmentList = departmentOptions.map((opt) => ({
    ...opt,
    checked: !!departmentChecked[opt.value],
  }));

  const handleDepartmentChange = (updatedList) => {
    const newDepartmentChecked = {};
    updatedList.forEach((item) => {
      newDepartmentChecked[item.value] = !!item.checked;
    });
    setDepartmentChecked(newDepartmentChecked);
  };

  const handleAddVivier = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('vivier_add');
  };

  const excludeAgency = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('exclude_agency');
  };

  const changeLocalisation = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('localisation_preferences');
  };

  const deleteVivier = async () => {
    setInfoVivier({
      idVivier: id,
      name: vivier?.name,
    });
    toggle('vivier_delete');
  };

  const changeUserVivierStatus = () => {
    setInfoVivier({
      idVivier: id,
      listUsers: listAddVivier,
    });
    toggle('vivier_change_status');
  };

  const excludeVivier = () => {
    setInfoVivier({
      idVivier: id,
      listUsers: listAddVivier,
    });
    toggle('vivier_delete_candidate');
  };

  // Grouper les users paginés par status pour le Kanban
  const userGroupedByVivierStatus = (result || []).reduce((acc, user) => {
    const vivierStatus = user.vivier_status;
    acc[vivierStatus] = acc[vivierStatus] || [];
    acc[vivierStatus].push(user);
    return acc;
  }, {});

  useEffect(() => {
    if (selectedColumn !== null) {
      setCurrentPage(1);
    }
  }, [selectedColumn]);

  const navigateListVivier = () => {
    if ((searchListVivier || searchListVivier === '') && pageListVivier) {
      navigate(
        `../listAllVivier?searchListVivier=${searchListVivier}&pageListVivier=${pageListVivier}&selectedVivier=${id}`
      );
    } else {
      navigate('../vivier');
    }
  };

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex flex-row items-center justify-between border-b border-gray-100 bg-white sticky top-0 z-20 py-3 px-3 tab:px-4 lg:px-8">
        <div className="flex items-center gap-3">
          <div
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft w={16} color="#111827" />
          </div>
          <div className="text-sm font-medium text-gray-900">
            {vivier?.name || ''}
          </div>
        </div>
        <div className=" flex items-center gap-4">
          {!isVivierExclude && (
            <div
              className={`text-gray-500 underline cursor-pointer`}
              onClick={() => {
                setModalData({
                  idVivier: id,
                });
                toggle('vivier_history');
              }}
            >
              {lastLogVivier ?? 'Pas encore notifié'}
            </div>
          )}
          {!isVivierExclude && (
            <div>
              <Button
                size={'SM'}
                color={globalUsersVivier?.length > 0 ? 'PRIMARY' : 'DISABLED'}
                disabled={globalUsersVivier?.length > 0 ? false : true}
                onClick={handleNotification}
              >
                <div className={'flex gap-2 items-center'}>
                  <div>
                    <BellIcon wh={20} color={'#FFFFFF'} />
                  </div>
                  <div>Notifier</div>
                </div>
              </Button>
            </div>
          )}
          {!isVivierLink && id !== '64e8cfd10b4f73f442432c9f' && (
            <div>
              <Button
                size={'SM'}
                color={'PRIMARY'}
                onClick={() => deleteVivier()}
              >
                Supprimer le vivier
              </Button>
            </div>
          )}
        </div>
      </div>
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-2 md:gap-3">
          <div className="flex gap-3">
          <FilterDropdown
            value={
              Object.keys(osChecked).filter((key) => osChecked[key]).length > 0
                ? `${Object.keys(osChecked).filter((key) => osChecked[key]).length} OS`
                : 'OS'
            }
            list={osList}
            onChange={handleOsChange}
            type="selectMultipleCheckbox"
          />
          <FilterDropdown
            value={
              Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length > 0
                ? Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length > 1
                  ? `${Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length} DÉPARTEMENTS`
                  : `${Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length} DÉPARTEMENT`
                : 'DÉPARTEMENT'
            }
            list={departmentList}
            onChange={handleDepartmentChange}
            type="selectMultipleCheckbox"
          />
          {id !== '64e8cfd10b4f73f442432c9f' && (
            <div className={'my-auto'}>
              <Button
                color={'SECONDARY'}
                size={'SMI'}
                className={'w-28'}
                onClick={() => setIsVivierKanban(!isVivierKanban)}
              >
                <div className={'flex gap-2'}>
                  <div className={'my-auto'}>
                    {isVivierKanban ? (
                      <KanbanIcon wh={20} color={'#374151'} />
                    ) : (
                      <TableIcon wh={20} color={'#374151'} />
                    )}
                  </div>
                  <div className={'my-auto'}>
                    {isVivierKanban ? 'Kanban' : 'Table'}
                  </div>
                </div>
              </Button>
            </div>
          )}
          <FilterDropdown
            value={<SortIcon wh={20} color={'#374151'} />}
            list={sortList}
            onChange={handleSortChange}
            type="selectMultipleRadio"
            showChevron={false}
          />
          <div className={'flex gap-3 my-auto'}>
            <div className="relative text-gray-500">
              <input
                name="search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                className="w-full h-10 pl-10 pr-8 ft-b border rounded-lg focus:border-yellow-500 focus:outline-none"
                type="text"
                placeholder="Rechercher ..."
                required
              />
              <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                <SearchLoop wh={18} color={'#666666'} />
              </div>
            </div>
            <select
              className="h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg focus:border-yellow-500 focus:outline-none"
              onChange={(e) => setOptionSearch(e.target.value)}
            >
              <option value="">Tous</option>
              <option value="id_bestt">ID BeSTT</option>
              <option value="name">Nom</option>
              <option value="mail">Email</option>
              <option value="phone">Téléphone</option>
            </select>
          </div>
          </div>
        </div>
      </SubNavbar>
      
      {/* Filtres par statut - entre SubNavbar et Table */}
      {!isVivierKanban && id !== '64e8cfd10b4f73f442432c9f' && (
        <div className="px-4 md:px-8 py-4 border-b border-gray-100 bg-white">
          <div className={'flex gap-4'}>
            {kanbanColumns.map((kanbanColumn, index) => (
              <div
                key={index}
                className={`rounded p-4 w-full h-full cursor-pointer border ${
                  selectedColumn === kanbanColumn.name
                    ? 'border-yellow-500 bg-yellow-50'
                    : 'border-gray-100 bg-gray-100'
                }`}
                onClick={() => {
                  if (selectedColumn === kanbanColumn.name) {
                    setSelectedColumn(null);
                    return;
                  }
                  setSelectedColumn(kanbanColumn.name);
                }}
              >
                <div className={'flex justify-between gap-1'}>
                  <div className={'flex gap-2 my-auto'}>
                    <div className={'my-auto text-xl'}>
                      {kanbanColumn.icon}
                    </div>
                    <div className={'my-auto'}>{kanbanColumn.title}</div>
                  </div>
                  <div className={'my-auto flex gap-1 items-center'}>
                    <div className={''}>
                      <Tooltip
                        text={kanbanColumn.description}
                        placement="top"
                      >
                        <div>
                          <InformationCircle wh={18} color={'#6B7280'} />
                        </div>
                      </Tooltip>
                    </div>
                    <div
                      className={`p-1 rounded w-fit h-fit text-sm ${
                        selectedColumn === kanbanColumn.name
                          ? 'bg-yellow-200 text-yellow-800'
                          : 'bg-gray-200'
                      }`}
                    >
                      {statusCounts[kanbanColumn.name] || 0}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-auto">
          {searchCandidatWaiting && (
            <div
              className={`flex flex-col ${
                width <= 460 ? 'gap-5' : 'gap-10'
              } justify-center items-center h-80`}
            >
              <div className={'animate-spin'}>
                <Loading2 wh={width <= 460 ? 40 : 60} color={'#FF9600'} />
              </div>
            </div>
          )}
          {!searchCandidatWaiting && (
            <>
              {isVivierKanban ? (
                <div className="p-3 tab:p-4 lg:p-8">
                  <KanbanFicheVivier
                    users={userGroupedByVivierStatus}
                    setSortName={setSortName}
                    sortName={sortName}
                    setAddVivier={setAddVivier}
                    list={listAddVivier}
                    idVivier={vivier._id}
                  />
                </div>
              ) : (
                  <TableFicheVivier
                  users={result}
                  setSortName={setSortName}
                  sortName={sortName}
                  setAddVivier={setAddVivier}
                  list={listAddVivier}
                  idVivier={vivier._id}
                />
              )}
            </>
          )}
        </div>
      </div>
      {!isVivierKanban &&
      !searchCandidatWaiting &&
      currentPage &&
      totalPages >= 1 &&
      setCurrentPage ? (
        <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
          <Pagination
            currentPage={currentPage}
            countPerPage={countPerPage}
            countTotal={countTotal}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </div>
      ) : null}

      {/* Fixed bottom bar for multiple selection actions */}
      {listAddVivier.length > 0 && (
        <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white p-1.5 rounded z-50">
          <div className="flex items-center text-sm h-10">
            <div className="flex gap-1 items-center py-2 px-3">
              <div className="w-fit">
                <Badge type="WARNING">{listAddVivier.length}</Badge>
              </div>
              sélectionné{listAddVivier.length > 1 ? 's' : ''}
            </div>
            <div className="w-0.5 h-1/2 self-center bg-white" />
            <button
              onClick={() => handleAddVivier()}
              className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
            >
              <Plus wh={16} color="#FFF" />
              <span>Ajouter au vivier</span>
            </button>
            <div className="w-0.5 h-1/2 self-center bg-white" />
            <button
              onClick={() => changeLocalisation()}
              className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
            >
              <Localisation wh={16} color="#FFF" />
              <span>Localisation</span>
            </button>
            <div className="w-0.5 h-1/2 self-center bg-white" />
            <button
              onClick={() => changeUserVivierStatus()}
              className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
            >
              <SwitchIcon wh={16} color="#FFF" />
              <span>Déplacer</span>
            </button>
            <div className="w-0.5 h-1/2 self-center bg-white" />
            <button
              onClick={() => excludeVivier()}
              className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
            >
              <CrossIcon wh={16} color="#FFF" />
              <span>Supprimer</span>
            </button>
            {id !== '64e8cfd10b4f73f442432c9f' && (
              <>
                <div className="w-0.5 h-1/2 self-center bg-white" />
                <button
                  onClick={() => excludeAgency()}
                  className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700 text-red-400"
                >
                  <BanIcon wh={16} color="#F87171" />
                  <span>Exclure</span>
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default BodyFicheVivier;
